import { useCallback, useEffect, useState } from 'react'

/**
 * Open state of the hamburger menu (dropdown on desktop, sheet on mobile). Pressing V for the
 * Select tool (`select-tool-activated`) closes it.
 */
export function useMenubarOpen(onMenuToggle?: (isOpen: boolean) => void) {
  const [open, setOpen] = useState(false)

  const handleMenuOpenChange = (isOpen: boolean) => {
    setOpen(isOpen)
    onMenuToggle?.(isOpen)
  }

  const closeMenu = useCallback(() => setOpen(false), [])

  useEffect(() => {
    const onSelectToolActivated = () => setOpen(false)

    window.addEventListener('select-tool-activated', onSelectToolActivated)
    return () => window.removeEventListener('select-tool-activated', onSelectToolActivated)
  }, [])

  return { open, handleMenuOpenChange, closeMenu }
}
